(function($) {
  'use strict';

    if($('.b-lol_alert__close').length){
      $('.b-lol_alert__close').on('click', function (e) {
        e.preventDefault();
        $(this).parent().hide();
    });
    }
})(jQuery);
